import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

export const NAVBAR_HEIGHT_BASELINE = 68;
export const NAVBAR_HEIGHT_DESKTOP = 88;

export const NavbarContainer = styled('nav')`
  width: 100%;
  height: ${pxToRem(NAVBAR_HEIGHT_BASELINE)};

  ${mediaQueries.desktop} {
    height: ${pxToRem(NAVBAR_HEIGHT_DESKTOP)};
  }
`;
